const PAX_DATA = 'paxData';
const GUARDIAN_DATA = 'guardianData';

class Cache {
  savePax = (token, data) => {
    const currentPaxes = JSON.parse(localStorage.getItem(PAX_DATA));
    localStorage.setItem(PAX_DATA, JSON.stringify({...currentPaxes, [token]: data}));
  };
  loadPax = (token) => {
    const pax = JSON.parse(localStorage.getItem(PAX_DATA));
    if (!pax) return null
    return pax[token]
  };
  saveGuardian = (token, data) => {
    const currentGuardians = JSON.parse(localStorage.getItem(GUARDIAN_DATA));
    localStorage.setItem(GUARDIAN_DATA, JSON.stringify({...currentGuardians, [token]: data}));
  };
  loadGuardian = (token) => {
    const guardian = JSON.parse(localStorage.getItem(GUARDIAN_DATA));
    if (!guardian) return null
    return guardian[token]
  };
  clearToken = (token) => {
    const pax = JSON.parse(localStorage.getItem(PAX_DATA));
    const guardian = JSON.parse(localStorage.getItem(GUARDIAN_DATA));
    if (pax && pax[token]) delete pax[token]
    if (guardian && [token]) delete guardian[token]
    localStorage.setItem(PAX_DATA, JSON.stringify(pax))
    localStorage.setItem(GUARDIAN_DATA, JSON.stringify(guardian))
  }
}

export default Cache;



// WEBPACK FOOTER //
// ./src/utils/cache.js